export default class ContactUsTypeColumn {
    constructor(rawData = {}) {
      this.id = rawData.id;
      this.labelName = rawData.labelName;
      this.active = rawData.active
    }
  }